import React from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography, Button, Divider } from "@material-ui/core";
import { useConfirm } from "material-ui-confirm";

import useSubscription from "../../Utils/useSubscription";
import { PanelSection, PanelContent, PanelDescription } from "../../Theme";

const Account = () => {
  const confirm = useConfirm();
  const history = useHistory();
  const { isTrial, isSubscriber, activeCycle, remainingDays } =
    useSubscription();
  const userEmail = useSelector((state) => state.user.userData.email);

  function handleChangePassword() {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/auth/forgot-password?email=${userEmail}`
      )
      .then(({ data }) => {
        confirm({
          title: "Falta pouco!",
          content:
            " Já te enviamos o email de redefinição de senha!. Acesse o seu email e clique no link para trocar de senha.",
          confirmationText: "Ok",
          cancellationText: "Fechar",
        });
      });
  }

  const subscribeInfo = () => {
    if (isSubscriber) {
      return (
        <Box display="flex" gridGap="20px" alignItems="center">
          <Typography>
            Plano {activeCycle?.subscription_plan_description} válido até{" "}
            {activeCycle?.end}
          </Typography>
        </Box>
      );
    }

    if (isTrial)
      return (
        <Box display="flex" gridGap="20px" alignItems="center">
          <Typography>
            Seu período de testes acaba em {remainingDays} dia(s)
          </Typography>
          <Button
            onClick={() => history.push("/plans")}
            variant="outlined"
            color="primary"
          >
            Assinar Agora
          </Button>
        </Box>
      );

    return (
      <Box display="flex" gridGap="20px" alignItems="center">
        <Typography>Expirada</Typography>
        <Button
          onClick={() => history.push("/plans")}
          variant="outlined"
          color="primary"
        >
          Assinar Agora
        </Button>
      </Box>
    );
  };

  return (
    <Box display="flex" flexDirection="column" gridRowGap="20px" width="100%">
      <PanelSection>
        <PanelDescription>Email</PanelDescription>
        <PanelContent>
          <Typography>{userEmail}</Typography>
        </PanelContent>
      </PanelSection>
      <PanelSection>
        <PanelDescription>Senha</PanelDescription>
        <PanelContent>
          <Button variant="outlined" onClick={handleChangePassword}>
            Trocar senha
          </Button>
        </PanelContent>
      </PanelSection>
      <PanelSection>
        <PanelDescription>Assinatura</PanelDescription>
        <PanelContent>{subscribeInfo()}</PanelContent>
      </PanelSection>
    </Box>
  );
};

export default Account;
